<div [attr.inert]="isDevToolsBlocked() ? '' : null">
  <app-header></app-header>
  <app-side-nav (sidebarToggled)="onSidebarToggled($event)"></app-side-nav>
</div>
<div class="main-content" [class.sidebar-collapsed]="sidebarCollapsed">
  <router-outlet></router-outlet>

  @if (isLoading() && !isLoaderSuppressed()) {
  <div class="spinner-wrapper">
    <mat-progress-spinner
      mode="indeterminate"
      diameter="60"
    ></mat-progress-spinner>
    @if (loaderMessage()) {
    <div class="loader-message">{{ loaderMessage() }}</div>
    }
  </div>
  }
</div>
<app-filter-banner></app-filter-banner>
